import React from 'react';
import { FaTimes, FaExclamationTriangle } from 'react-icons/fa';
import '../styles/InventoryEquipment.css';

function formatDate(raw) {
  if (!raw) return '—';
  const d = new Date(raw);
  if (Number.isNaN(d.getTime())) return '—';
  return d.toLocaleDateString('en-AU', {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
  });
}

function formatMoney(n) {
  const v = Number(n);
  if (!Number.isFinite(v)) return '—';
  return v.toLocaleString('en-AU', {
    style: 'currency',
    currency: 'AUD',
    maximumFractionDigits: 0,
  });
}

function statusLabel(status) {
  return String(status) === 'ServiceDue' ? 'Service Due' : 'Active';
}

function statusClass(status) {
  return String(status) === 'ServiceDue' ? 'ieq-pill--inservice' : 'ieq-pill--active';
}

function isServiceDue(row) {
  if (String(row?.status) === 'ServiceDue') return true;
  if (!row?.serviceDueDate) return false;
  const d = new Date(row.serviceDueDate);
  return !Number.isNaN(d.getTime()) && d <= new Date();
}

export default function VehicleDetailModal({ vehicle, onClose, onEdit }) {
  if (!vehicle) return null;

  const due = isServiceDue(vehicle);
  const title =
    [vehicle.make, vehicle.model].filter(Boolean).join(' ') || vehicle.makeModel;

  return (
    <div className="ieq-overlay" role="dialog" aria-modal="true">
      <div className="ieq-modal ieq-modal--detail">
        <header className="ieq-modal-header">
          <h2>Vehicle — {vehicle.vehicleNumber}</h2>
          <button
            type="button"
            className="ieq-modal-close"
            onClick={onClose}
            aria-label="Close"
          >
            <FaTimes />
          </button>
        </header>

        <div className="ieq-modal-body">
          <div className="ieq-badges">
            <span className="ieq-code-badge">{vehicle.vehicleNumber}</span>
            <span className={`ieq-pill ${statusClass(vehicle.status)}`}>
              {statusLabel(vehicle.status)}
            </span>
          </div>

          <h3 className="ieq-title">{title}</h3>

          <div className="ieq-detail-cards">
            <div className="ieq-detail-card">
              <b>Make / Model</b>
              <span>{title || '—'}</span>
            </div>
            <div className="ieq-detail-card">
              <b>Registration</b>
              <span>{vehicle.registration || '—'}</span>
            </div>
            <div className="ieq-detail-card">
              <b>Assigned Driver</b>
              <span>{vehicle.assignedDriver || '—'}</span>
            </div>
            <div className="ieq-detail-card">
              <b>Current Site</b>
              <span>{vehicle.currentSite || '—'}</span>
            </div>
            <div className="ieq-detail-card">
              <b>Fuel This Month</b>
              <span>{formatMoney(vehicle.fuelThisMonth)}</span>
            </div>
            <div className="ieq-detail-card">
              <b>Service Due</b>
              <span>{formatDate(vehicle.serviceDueDate)}</span>
            </div>
            <div className="ieq-detail-card">
              <b>Registration Expiry</b>
              <span>{formatDate(vehicle.registrationExpiry)}</span>
            </div>
          </div>

          {due && (
            <div className="ieq-alert ieq-alert--info">
              <FaExclamationTriangle />
              <span>
                This vehicle is due for service on{' '}
                {formatDate(vehicle.serviceDueDate)}. Please schedule a service.
              </span>
            </div>
          )}

          <div className="ieq-modal-footer">
            <button type="button" className="ieq-btn" onClick={onClose}>
              Close
            </button>
            <button
              type="button"
              className="ieq-btn ieq-btn--primary"
              onClick={() => onEdit?.(vehicle)}
            >
              Edit Vehicle
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
